import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree, } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class PreviewGuard implements CanActivate {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        let preview = this.document.querySelector("app-root")?.getAttribute("preview");
        if(preview){
            return true;
        }
        return false;        
    }
}